var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{key:_vm.key,staticClass:"gateway",style:(_vm.nodeStyle)},[_c('img',{attrs:{"src":_vm.gateway}}),_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }